/* eslint-disable */

import { create } from 'apisauce'

export const config = async () => {
  const token = await localStorage.getItem(process.env.REACT_APP_XITS_TOKEN_KEY)

  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Device-Type': window.navigator.userAgent,
    },
  }
}

export const multiPartConfig = async () => {
  const token = await localStorage.getItem(process.env.REACT_APP_XITS_TOKEN_KEY)
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'multipart/form-data/json',
      'Device-Type': window.navigator.userAgent,
    },
  }
}

export const apiClient = create({
  baseURL:
    process.env.REACT_APP_XITS_API_KEY_ADDRESS +
    process.env.REACT_APP_XITS_API_KEY_BASE_URL,
})

const responseMonitor = (response) => {
  if (response.status === 401) {
    window.postMessage('NotAuthorized')
  }

  if (response.status === 403) {
    console.log('here')
    window.postMessage('NoPermission')
  }
}

apiClient.addMonitor(responseMonitor)
